import { Close as CloseIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { useSnackbarContext } from 'pages/ParentHelper/providers/SnackbarProvider/hooks';

import type { FC } from 'react';

export const SnackbarCloseButton: FC = () => {
  const { onClose } = useSnackbarContext();

  return (
    <IconButton
      size="small"
      aria-label="close"
      color="inherit"
      onClick={onClose}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};
